import {useEffect, useMemo, useRef, useState} from 'preact/hooks';
import {Header, Footer} from '@baidu/qianfan-portal-common';
import '@baidu/qianfan-portal-common/esm/index.css';

import {useScrollToAnchor} from '~/utils';
import {getBceAuthInfo} from 'utils';
import {
    Banner,
    ProductFeatures,
    TypicalCase,
    ModelFeatures,
    Reason,
    Support,
    ServiceMode,
    Product,
    Nav,
    // Header,
    // Footer
} from '~/components/sections/wenxin/index';
import {banner, typicalCase, support, serviceMode, products} from '~/locals/wenxin/index';
import {headerSdk, footerSdk} from '~/locals/qianfan/index';
import '~/style/wenxin/index.less';
// import poster from '~/assets/wenxin/foundation-poster-fff.png';

// const mp4 = 'https://aip-static.cdn.bcebos.com/landing/wenxinworkshop/foundation-fff-20230904.mp4';
const offset = 10;
const {columns, qrCodes, copyRight} = footerSdk;
export default function Wenxin() {
    const [userInfo, setUserInfo] = useState();
    const navContentRef = useRef(null);
    const bannerRef = useRef(null);
    const {menuList, logoInfo} = headerSdk;

    // 添加二级导航Nav组件，并绑定锚点滚动事件
    // useEffect(() => {
    //     const handleScrollFn = () => {
    //         const header = document.querySelector('.cloud-header-pc .cloud-header-default');
    //         const wapHeader = document.querySelector('.cloud-header-wap .cloud-header-wrapper-wap');
    //         const banner = bannerRef.current.base.getBoundingClientRect();
    //         const scrollTop = Math.abs(banner.top);
    //         if (header) {
    //             if (scrollTop >= banner.height - 100 && scrollTop < banner.height) {
    //                 header.style = `position: absolute;
    //                     top: ${12 - (scrollTop - banner.height + 100)}px`;
    //             }
    //             else if (scrollTop >= banner.height) {
    //                 header.style = `position: absolute;
    //                     top: -62px`;
    //             }
    //             else if (scrollTop === 0) {
    //                 header.style = 'position: fixed;top: 0';
    //             }
    //             else {
    //                 header.style = 'position: fixed;top: 12px';
    //             }
    //         }
    //         else {
    //             if (wapHeader) {
    //                 if (scrollTop >= banner.height) {
    //                     wapHeader.style = `
    //                         top: -54px;transition:top 300ms ease-in-out`;
    //                 }
    //                 else {
    //                     wapHeader.style = `
    //                         top: 0;transition:top 300ms ease-in-out`;
    //                 }
    //             }
    //         }
    //     };
    //     window.addEventListener('scroll', handleScrollFn);
    // }, []);

    return (
        <>
            {/* <Header bannerRef={bannerRef} navContentRef={navContentRef} userInfo={userInfo} type="modelBuilder" /> */}
            {/* <Header logo={logoInfo} menus={menuList} /> */}
            <Banner ref={bannerRef} />
            {/* <Nav navContentRef={navContentRef} bannerRef={bannerRef} /> */}
            <div style={{background: '#EBF4FF'}}>
                <div className="scroll-container">
                    <ProductFeatures />
                    <ModelFeatures />
                </div>
                <Reason />
                <TypicalCase typicalCase={typicalCase} />
                <Support support={support} className="support-item" />
                <ServiceMode serviceMode={serviceMode} />
                <Product products={products} />
            </div>
            {/* <Footer /> */}
            {/* <Footer columns={columns} qrCodes={qrCodes} copyRight={copyRight} /> */}
        </>
    );
}
